(function(){
  var bar = document.getElementById('MiSticky');
  var shown = false;
  function onScroll(){
    if(!bar) return;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var show = y > 320;
    if (show !== shown){ shown = show; bar.classList.toggle('is-visible', show); }
  }
  if (bar){ window.addEventListener('scroll', onScroll, { passive: true }); onScroll(); }

  function plPlural(n){
    if (n === 1) return 'produkt';
    var t = n % 10, h = n % 100;
    if (t >= 2 && t <= 4 && !(h >= 12 && h <= 14)) return 'produkty';
    return 'produktów';
  }
  function money(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' zł'; }

  function syncOriginalHeader(c){
    var n = (c && c.item_count) || 0;
    document.querySelectorAll('.item-shopping-cart .icon a span').forEach(function(s){ s.textContent = n; });
    document.querySelectorAll('.item-shopping-cart .total-item').forEach(function(s){ s.textContent = n + ' ' + plPlural(n); });
    document.querySelectorAll('.item-shopping-cart .subtotal-info-wrapper .woocommerce-Price-amount').forEach(function(s){
      s.innerHTML = '<bdi>' + money((c && c.total_price) || 0) + '</bdi>';
    });
    document.querySelectorAll('.item-shopping-cart .shopping-cart-list .cart_list').forEach(function(ul){
      if (n > 0){ ul.innerHTML = '<li class="mi-cart-go"><a href="/cart">Zobacz koszyk (' + n + ')</a></li>'; }
    });
  }

  function refreshCount(){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        if (bar){
          var el = bar.querySelector('.mi-stickybar__count');
          if (el){
            if (c && c.item_count > 0){ el.textContent = c.item_count; el.hidden = false; }
            else { el.hidden = true; }
          }
        }
        syncOriginalHeader(c);
      }).catch(function(){});
  }
  refreshCount();
  document.addEventListener('cart:updated', refreshCount);
  window.addEventListener('pageshow', function(e){ if (e.persisted) refreshCount(); });
})();

/* === Naprawa formularza kontaktowego: stary WordPress CF7 -> natywny /contact Shopify === */
(function(){
  function rewire(){
    var f = document.querySelector('form.wpcf7-form, form[action*="wpcf7"]');
    if(!f || f.getAttribute('data-mi-contact-fixed')) return;
    f.setAttribute('data-mi-contact-fixed','1');
    f.setAttribute('action','/contact');
    f.setAttribute('method','post');
    var map = {'your-name':'contact[name]','your-email':'contact[email]','your-message':'contact[body]'};
    Object.keys(map).forEach(function(k){
      var el = f.querySelector('[name="'+k+'"]');
      if(el) el.setAttribute('name', map[k]);
    });
    function hid(n,v){ var i=document.createElement('input'); i.type='hidden'; i.name=n; i.value=v; f.appendChild(i); }
    hid('form_type','contact');
    hid('utf8','✓');
    f.addEventListener('submit', function(e){ e.stopImmediatePropagation(); }, true);
  }
  function ready(){
    rewire(); setTimeout(rewire,800); setTimeout(rewire,2000);
    if(/[?&]contact_posted=true/.test(location.search)){
      var f = document.querySelector('form[action="/contact"]') || document.querySelector('.wpcf7');
      if(f){
        var d=document.createElement('div');
        d.textContent='Dziękujemy! Twoja wiadomość została wysłana. Odpowiemy najszybciej, jak to możliwe.';
        d.style.cssText='padding:12px 16px;margin:0 0 16px;background:#e7f6e7;border:1px solid #9ad29a;border-radius:8px;color:#14532d;font-weight:600';
        (f.parentNode||document.body).insertBefore(d, f);
        f.scrollIntoView({behavior:'smooth',block:'center'});
      }
    }
  }
  if(document.readyState!=='loading') ready(); else document.addEventListener('DOMContentLoaded', ready);
})();

/* === Fix: ucinane teksty w kartach sklepu (WP mi-shop) — wymuszamy zawijanie zamiast przycinania === */
(function(){
  var css = '.mi-shop__title,.mi-shop__author,.mi-shop__cat{white-space:normal !important;overflow:visible !important;text-overflow:clip !important;max-width:none !important;-webkit-line-clamp:none !important;word-break:normal !important;overflow-wrap:anywhere !important;}'
    + '.mi-shop__body{overflow:visible !important;}';
  var s=document.createElement('style'); s.setAttribute('data-mi-fix','shop-clip'); s.appendChild(document.createTextNode(css));
  (document.head||document.documentElement).appendChild(s);
})();
